import download from 'downloadjs'
import { ExportDataColumn } from '../dtos/ExportDataColumn.dto'

export class ExportDataProvider {
	static downloadCSV(data: any[], columns: ExportDataColumn[], filename?: string) {
		const rows = data.map((dado) => columns.map(({ key }) => dado[key]))

		const header = columns.map((column) =>
			column.title.normalize('NFD').replace(/[^a-zA-Z\s]/g, ''),
		)

		const csv = [header, ...rows].map((m) => m.join(';')).join('\r\n')

		download(csv, `${filename || 'Arquivo de exportação'}.csv`, 'text/csv')
	}
}
